<template>
  <router-view />
</template>

<script>

export default {
  name: 'App',
  components: {
  },
}
</script>

<style>
*{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  letter-spacing: 1px;
}
</style>
